import { useNumericParams } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

import defaultRequestOptions from '@sections/Client/packs/Accounting/defaultRequestOptions'

import InvoiceEditRoutes from './routes'

const InvoiceEdit = () => {
  const { invoiceId } = useNumericParams()

  useReduxAction(
    'invoices',
    'loadInvoice',
    {
      entityId: invoiceId,
      ...defaultRequestOptions.invoice,
    },
    [invoiceId],
    {
      dispatchAction: (action, requestOptions) => action(invoiceId, requestOptions),
      // @ts-expect-error TS2322
      shouldPerformFn: ({ loading }) => invoiceId && !loading,
    },
  )

  return (
    <InvoiceEditRoutes />
  )
}

export default InvoiceEdit
